$ = require 'jquery'
_ = require 'underscore'
jwtDecode = require 'jwt-decode'
Promise = require 'bluebird'
xtend = require 'xtend'

Alerts = require 'app/scripts/views/lib/alerts'
alertTemplate = require 'app/scripts/views/templates/plugin_alert'
ApiPromise = require 'app/scripts/network/api-promise'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
defaultPowerUpIcon = require 'resources/images/directory/icons/customIcon.png'
Dialog = require 'app/scripts/views/lib/dialog'
isWebClientPage = require 'app/scripts/lib/util/url/is-web-client-page'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ firstPartyPluginsOrg } = require '@trello/config'
{ getScreenFromUrl } = require '@trello/atlassian-analytics'
ninvoke = require 'app/scripts/lib/util/ninvoke'
ModelCache = require 'app/scripts/db/model-cache'
ModelLoader = require 'app/scripts/db/model-loader'
PluginBoardBar = require 'app/scripts/views/lib/plugin-board-bar'
PluginHandlerContext = require 'app/scripts/views/internal/plugins/plugin-handler-context'
PluginModal = require 'app/scripts/views/lib/plugin-modal'
PluginModelSerializer = require 'app/scripts/views/internal/plugins/plugin-model-serializer'
PluginOverlayView = require 'app/scripts/views/plugin/plugin-overlay-view'
PluginPopOverIFrameView = require 'app/scripts/views/plugin/plugin-pop-over-iframe-view'
PluginPopOverConfirmView = require 'app/scripts/views/plugin/plugin-pop-over-confirm-view'
PluginPopOverDateTimeView = require 'app/scripts/views/plugin/plugin-pop-over-datetime-view'
PluginPopOverListView = require 'app/scripts/views/plugin/plugin-pop-over-list-view'
PopOver = require 'app/scripts/views/lib/pop-over'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
processCallbacks = require 'app/scripts/views/internal/plugins/plugin-process-callbacks'
{ sendPluginScreenEvent, sendPluginTrackEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
{ trackUe } = require '@trello/analytics'
{ siteDomain } = require '@trello/config'
{ navigate } = require 'app/scripts/controller/navigate'
{ currentModelManager } = require 'app/scripts/controller/currentModelManager'

INVALID_HEIGHT = "Invalid height, must be a positive number"
INVALID_URL = "Invalid url, must be http or https"
MISSING_BOARD = "Invalid context, missing board"
MISSING_CARD = "Invalid context, missing card"
MISSING_CONTEXT = "Missing context, command requires context"
MISSING_EL = "Invalid context, missing el (or attempt to use el after initial request)"
MISSING_LIST = "Invalid context, missing list"
MISSING_MEMBER = "Invalid context, missing member"
CARD_NOT_FOUND = "Card not found or not on current board"
MISSING_ORG = "Invalid context, missing organization"
DISABLED = "Plugin disabled on board"
INVALID_CONTEXT = "Invalid context, unable to deserialize"

BUTLER_POWER_UP_ID = require 'app/scripts/data/butler-id'

isInPopOver = (t, context) ->
  { el } = context

  if el? && (PopOver.contains(el) || PopOver.toggledBy(el))
    return true

  if (iframe = iframeFromHost(t))? && PopOver.contains(iframe)
    return true

  false

currentOverlayView = null
closeOverlay = ->
  currentOverlayView?.remove()
  currentOverlayView = null
  return

jwtCache = new Map()
jwtCacheClearInterval = null
jwtCacheClearPeriod = 60000
clearJWTCache = ->
  jwtCache.forEach (val, key) ->
    if val.expires < Date.now() + 60000
      jwtCache.delete(key)
  if jwtCache.size == 0
    # empty cache, pause the garbage cleaner
    clearInterval(jwtCacheClearInterval)
    jwtCacheClearInterval = null

# WARNING: The context is supplied by the power-up, and shouldn't necessarily
# be trusted.
module.exports = ({ idPlugin, allowRestricted }) ->
  mapHandlers = (handlers) ->
    _.mapObject handlers, (fx) ->
      (t, options) ->
        if !(context = options?.context)?
          throw t.NotHandled("Missing context")

        # Process any callbacks in the options we were given, since some things
        # like popups might be using them
        runCallback = ({ command, el, options: commandOptions }) ->
          Promise.using PluginHandlerContext.serialize({ el }), (callbackContext) ->
            t.request command, xtend commandOptions,
              context: PluginHandlerContext.extend(context, callbackContext)
            .then (response) =>
              processCallbacks response, runCallback
        options = processCallbacks options, runCallback

        try
          deserializedContext = PluginHandlerContext.deserialize(context, idPlugin)
        catch err
          if err instanceof PluginHandlerContext.Error.PluginDisabled
            throw t.PluginDisabled(DISABLED)

        if !deserializedContext?
          throw t.InvalidContext(INVALID_CONTEXT)

        fx.call handlers, t, xtend options,
          context: deserializedContext

  getArgs = (t, args, required, allowAnonymous) ->
    { context, idCard } = args

    if context? && currentModelManager.onAnyCardView()
      currentCardModel = currentModelManager.currentModel.get()
      if currentCardModel
        context = xtend context,
          card: currentCardModel
          board: currentCardModel.getBoard()
          member: Auth.me()

    # anonymous requests will have null or empty contexts
    if !context? || Object.keys(context).length == 0
      if !allowAnonymous # only whitelisted commands can go forward
        throw t.NotHandled(MISSING_CONTEXT)
      if !(Controller.getCurrentBoard())?.isPluginEnabled(idPlugin)
        throw t.PluginDisabled(DISABLED)
      context =
        board: Controller.getCurrentBoard()
        member: Auth.me()

    { board, card, el, list, member } = context
    if required?.board && !board? then throw t.NotHandled(MISSING_BOARD)
    if required?.el && !el? then throw t.NotHandled(MISSING_EL)
    if required?.list && !list? then throw t.NotHandled(MISSING_LIST)
    if required?.member && !member? then throw t.NotHandled(MISSING_MEMBER)

    if idCard?
      if !board? then throw t.NotHandled(MISSING_BOARD)
      if !(card = board.getCard(idCard))? then throw t.NotHandled(CARD_NOT_FOUND)

    if required?.card && !card? then throw t.NotHandled(MISSING_CARD)

    return xtend args, { context: xtend(context, { card }) }

  handlers =
    'data': (t, opts) ->
      { board, card } = getArgs(t, opts, { board: true }, true).context
      cardPluginData = card?.getPluginData(idPlugin)
      memberPluginData = Auth.me()?.getPluginData(idPlugin)
      xtend board.getPluginData(idPlugin), cardPluginData, memberPluginData

    'set': (t, opts) ->
      { context: { board, card }, scope, visibility, data } = getArgs(t, opts, { board: true }, true)

      if visibility !in ['private', 'shared'] then throw t.NotHandled("Invalid value for visibility")
      if !_.isString(data) then throw t.NotHandled("Invalid value for data")

      target = switch scope
        when 'card'
          card || throw t.NotHandled("Card scope not available without card context")
        when 'board'
          board
        when 'member'
          Auth.me() || throw t.NotHandled("No active member")
        when 'organization'
          board.getOrganization() || throw t.NotHandled("Unable to save plugin data at the organization level because the member is not in the organization")
        else
          throw t.NotHandled("Invalid value for scope")

      # private data can be set relative to models even if the models themselves aren't directly editable
      # for example storing a private auth token for a member on a public board they aren't a member of
      if visibility == 'shared'
        if (scope == 'card' || scope == 'board') && !target?.editable()
          throw t.NotHandled("Scope not editable by active member")
        else if scope == 'organization' && !target.hasActiveMembership(Auth.me())
          throw t.NotHandled("Scope not editable by active member")

      # before we set shared plugindata do a heuristic check to determine
      # if anything sensitive might be being stored here and prevent it
      if visibility == 'shared' && /"(?:(?:auth|refresh)?[_-]?token|secret)":/i.test(data)
        trackUe('Power-Up', 'prevented by', 'Plugin handler', '', '', 'setting shared secret', idPlugin)
        throw t.NotHandled("Detected potential secret. You should never store secrets like tokens in shared pluginData. See: https://developers.trello.com/v1.0/reference#t-set")

      target.setPluginData(idPlugin, visibility, data)
      return

    'navigate': (t, opts) ->
      getArgs(t, opts, {})
      { url } = opts
      if !pluginValidators.isValidUrlForIframe(url)
        throw t.NotHandled(INVALID_URL)

      if !isWebClientPage(url)
        throw t.NotHandled("Navigation only allowed to Trello client URLs")

      urlTarget = url
        .replace(/// ^ #{ siteDomain } ///, '')
        .replace(/// ^ /(?=.) ///, '')

      # location.pathname has a leading "/"; urlTarget does not
      # nothing to do if the url requested is the current url
      if urlTarget != location.pathname.slice(1)
        trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'navigate', idPlugin)
        navigate(urlTarget, { trigger: true })
      return

    'showCard': (t, opts) ->
      { card } = getArgs(t, opts, { card: true }).context
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'showCard', idPlugin)
      # to prevent the card appearing behind a modal or overlay, close those first
      closeOverlay()
      PluginModal.close()
      Controller.showCardDetail(card)

    'hideCard': (t, opts) ->
      getArgs(t, opts, {})
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'hideCard', idPlugin)
      if Controller.onCardView()
        Dialog.hide()

    'alert': (t, opts) ->
      { board } = getArgs(t, opts, { board: true }).context
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'alert', idPlugin)
      { isValidAlertDisplayType, isValidAlertDuration, isValidStringLength } = pluginValidators
      # required to have a message
      if !isValidStringLength(opts?.message, 1, 140)
        throw t.NotHandled('Invalid message. Must be string and within 140 characters')
      plugin = ModelCache.get('Plugin', idPlugin)
      identifier = "plugin-#{idPlugin}"
      templateData = {
        message: opts?.message || '',
        name: plugin.get('name')
        icon: plugin.get('icon')?.url || defaultPowerUpIcon
      }
      content = alertTemplate(templateData)
      displayType = if isValidAlertDisplayType(opts.display) then opts.display else 'info'
      # map displayType to internal values
      displayMap = { info: 'neutral', success: 'info', error: 'error', warning: 'warning' }
      displayType = displayMap[displayType]
      duration = if isValidAlertDuration(opts.duration) then opts.duration else 5
      Alerts.showHtml(content, displayType, identifier, duration * 1000)

      sendPluginScreenEvent({
        idPlugin: idPlugin
        idBoard: board.id
        screenName: 'pupAlertInlineDialog'
        attributes:
          display: displayType
      })

      return

    'hideAlert': (t, opts) ->
      getArgs(t, opts, {})
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'hideAlert', idPlugin)
      Alerts.hide("plugin-#{idPlugin}")
      return

    'popup': (t, opts) ->
      { context, title, content, callback, pos } = getArgs(t, opts, { board: true })
      { board, el } = context

      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'popup', idPlugin)

      getView = ->
        options = { model: board, title, content, callback }
        switch content.type
          when 'iframe'
            if !pluginValidators.isValidUrlForIframe(content.url)
              throw t.NotHandled(INVALID_URL)
            if content.height? && !pluginValidators.isValidHeight(content.height)
              throw t.NotHandled(INVALID_HEIGHT)
            new PluginPopOverIFrameView(options)
          when 'list'
            new PluginPopOverListView(options)
          when 'confirm'
            new PluginPopOverConfirmView(options)
          when 'date', 'datetime'
            new PluginPopOverDateTimeView(options)
          else
            throw t.NotHandled("Unknown type for popup")

      iframe = iframeFromHost(t)

      if isInPopOver(t, context)
        PopOver.pushView
          view: getView()
      else if el?
        PopOver.toggle
          elem: el
          view: getView()
      else if pos? && iframe && pluginValidators.isValidPopupPos(pos)
        iframeBoundingClientRect = iframe.getBoundingClientRect()
        PopOver.toggle
          clientx: pos.x + iframeBoundingClientRect.left
          clienty: pos.y + iframeBoundingClientRect.top
          view: getView()
      else
        throw t.NotHandled(MISSING_EL)

      sendPluginScreenEvent({
        idPlugin: idPlugin
        idBoard: board.id
        screenName: 'pupPopupInlineDialog'
        attributes:
          popupType: if content.search then 'search' else content.type
      })

      return

    'close-popup': (t, opts) ->
      getArgs(t, opts, {})
      { context } = opts
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'close-popup', idPlugin)
      if isInPopOver(t, context)
        PopOver.hide()
      else
        console?.error('Error: No popover in context. Are you using the correct t?')
      return

    # deprecated in favor of close-popup
    'pop-popup': (t, opts) ->
      getArgs(t, opts, {})
      { context } = opts
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'pop-popup', idPlugin)
      if isInPopOver(t, context)
        PopOver.popView()
      return

    'overlay': (t, opts) ->
      { context: { board }, content } = getArgs(t, opts, { board: true })
      whitelist = featureFlagClient.get('platform.overlay_deprecation_whitelist', [])
      explicitlyAllowed = idPlugin in whitelist
      if !explicitlyAllowed && idPlugin > '5bcd4b400000000000000000' # Id representing Oct 22, 2018
        trackUe('Plugin handler', 'rejects', 'Power-Up', '', '', 'overlay', idPlugin)
        throw t.NotHandled('t.overlay is deprecated and is unavailable to Power-Ups created after Oct 22, 2018')

      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'overlay', idPlugin)

      if !pluginValidators.isValidUrlForIframe(content.url)
        throw t.NotHandled(INVALID_URL)

      closeOverlay()
      # close any currently open PopOvers before drawing the overlay
      PopOver.hide()

      plugin = ModelCache.get('Plugin', idPlugin)
      ownedByTrello = plugin.get('idOrganizationOwner') == firstPartyPluginsOrg
      if content.inset && ownedByTrello
        Controller.getCurrentBoardView().toggleButler(content.url)
      else
        currentOverlayView = new PluginOverlayView({ model: board, content })
        $('#chrome-container').append(currentOverlayView.render().el)

      sendPluginScreenEvent({
        idPlugin: idPlugin
        idBoard: board.id
        screenName: 'pupOverlayModal'
      })

      return

    'close-overlay': (t, opts) ->
      args = getArgs(t, opts, { board: true })
      boardView = Controller.getCurrentBoardView()
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'close-overlay', idPlugin)

      plugin = ModelCache.get('Plugin', idPlugin)
      ownedByTrello = plugin.get('idOrganizationOwner') == firstPartyPluginsOrg
      if args.inset && ownedByTrello && boardView.butlerView?
        boardView.toggleButler()
      else if currentOverlayView?
        closeOverlay()
      else
        console?.warn('Warning: No overlay is being displayed')
      return

    'modal': (t, opts) ->
      { context: { board }, content } = getArgs(t, opts, { board: true })
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'modal', idPlugin)

      if !pluginValidators.isValidUrlForIframe(content.url)
        throw t.NotHandled(INVALID_URL)

      if content.height? && !pluginValidators.isValidHeight(content.height)
        throw t.NotHandled(INVALID_HEIGHT)

      plugin = ModelCache.get('Plugin', idPlugin)

      if !_.isString(content.title)
        content.title = plugin?.get('name') || ''
      content.title = content.title.trim()

      content.idPlugin = idPlugin

      PluginModal.open({ model: board, content })

      sendPluginScreenEvent({
        idPlugin: idPlugin
        idBoard: board.id
        screenName: 'pupModalModal'
        attributes:
          fullscreen: content.fullscreen == true
          totalActions: if content.actions then content.actions.length else 0
      })

      return

    'update-modal': (t, opts) ->
      { context: { board }, content } = getArgs(t, opts, { board: true })
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'update-modal', idPlugin)

      content.idPlugin = idPlugin

      PluginModal.update(content)
      return

    'close-modal': (t, opts) ->
      getArgs(t, opts, {})
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'close-modal', idPlugin)
      PluginModal.close()

    'board-bar': (t, opts) ->
      { context: { board }, content } = getArgs(t, opts, { board: true })
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'board-bar', idPlugin)

      if !pluginValidators.isValidUrlForIframe(content.url)
        throw t.NotHandled(INVALID_URL)

      if content.height? && !pluginValidators.isValidHeight(content.height)
        throw t.NotHandled(INVALID_HEIGHT)

      plugin = ModelCache.get('Plugin', idPlugin)

      if !content.title
        content.title = plugin?.get('name') || ''

      PluginBoardBar.open({ model: board, content: content })

      sendPluginScreenEvent({
        idPlugin: idPlugin
        idBoard: board.id
        screenName: 'pupBoardBarModal'
        attributes:
          totalActions: if content.actions then content.actions.length else 0
          resizable: content.resizable == true
      })

      return

    'close-board-bar': (t, opts) ->
      getArgs(t, opts, {})
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'close-board-bar', idPlugin)
      PluginBoardBar.close()

    'resize': (t, { height }) ->
      if !pluginValidators.isValidHeight(height)
        throw t.NotHandled(INVALID_HEIGHT)
      iframe = iframeFromHost(t)
      if iframe
        if $(iframe).parents('.plugin-modal>.fullscreen').length
          console?.warn("Warning: Fullscreen modals cannot be resized with t.sizeTo")
          return
        if height
          # we want to restrict the vertical height of the board bar to 40% the height of the board
          if $(iframe).parents('.plugin-board-bar').length
            PluginBoardBar.setDesiredHeight(height)
            PluginBoardBar.restrictHeight()
          else
            iframe.style.height = "#{ height }px"
      else
        throw t.NotHandled("Could not find iframe to resize")
      return

    'card': (t, opts) ->
      { context: { card }, fields } = getArgs(t, opts, { card: true })
      PluginModelSerializer.card(card, fields)

    'cards': (t, opts) ->
      { context: { board }, fields } = getArgs(t, opts, { board: true }, true)
      PluginModelSerializer.cards(board.openCards(), fields)

    'list': (t, opts) ->
      getArgs(t, opts, {})
      { context, fields } = opts
      Promise.try ->
        if (list = context.list)?
          return list

        if (card = context.card)?
          if (list = card.getList())?
            return list

          return ModelLoader.getCardList(card.id)

        null
      .then (list) ->
        if !list?
          throw t.NotHandled(MISSING_LIST)

        PluginModelSerializer.list(list, fields)

    'lists': (t, opts) ->
      { context: { board }, fields } = getArgs(t, opts, { board: true }, true)
      PluginModelSerializer.lists(board.listList.models, fields)

    'member': (t, opts) ->
      { context: { member }, fields } = getArgs(t, opts, { member: true }, true)
      PluginModelSerializer.member(member, fields)

    'board': (t, opts) ->
      { context: { board }, fields } = getArgs(t, opts, { board: true }, true)
      PluginModelSerializer.board(board, fields)

    'attach-to-card': (t, opts) ->
      { context: { card, board }, url, name, mimeType } = getArgs(t, opts, { card: true, board: true })
      trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'attach-to-card', idPlugin)
      ninvoke card, 'uploadUrl', { url, name, mimeType }
      .then (data) =>
        source = getScreenFromUrl()
        sendPluginTrackEvent({
          idPlugin: idPlugin
          idBoard: board.id
          idCard: card.id
          event:
            action: 'created'
            actionSubject: 'attachment'
            source: source
        })
      .return()

    'organization': (t, opts) ->
      { context: { board }, fields } = getArgs(t, opts, { board: true }, true)
      if board.hasOrganization()? && board.getOrganization()?
        PluginModelSerializer.organization(board.getOrganization(), fields)
      else
        throw t.NotHandled(MISSING_ORG)

    'jwt': (t, opts) ->
      { context: { board, member }, state } = getArgs(t, opts, { board: true, member: true }, true)
      if state? && (!_.isString(state) || state.length > 2048)
        throw t.NotHandled('Provided state must be a string, less than 2048 characters in length')
      cacheKey = "#{idPlugin}:#{state || ''}"
      cached = jwtCache.get(cacheKey)
      if cached? && cached.expires > Date.now() + 60000
        return cached.jwt
      ApiPromise
        url: "/1/plugin/#{idPlugin}/jwt"
        data:
          idBoard: board.id
          state: state || ''
        type: 'post'
      .then (resp) ->
        jwt = resp.jwt
        decoded = jwtDecode(jwt)
        jwtCache.set(cacheKey, { jwt: jwt, expires: decoded.exp * 1000 })
        if !jwtCacheClearInterval?
          # enable the garbage collector
          jwtCacheClearInterval = setInterval(clearJWTCache, jwtCacheClearPeriod)
        return jwt

  if allowRestricted
    _.extend handlers,
      'request-token': (t, { context, name, key, scope }) ->
        trackUe('Power-Up', 'requests', 'Plugin handler', '', '', 'request-token', idPlugin)
        if !key
          throw t.NotHandled("Missing API key")
        if !name
          throw t.NotHandled("Missing app name")
        if !scope
          throw t.NotHandled("Missing scope")
        return new Promise((resolve, reject) ->
          handlePost = (data) ->
            token = /<pre>\s*([0-9a-f]+)\s*<\/pre>/.exec(data)
            if !token
              return reject(t.NotHandled("Failed to fetch token"))
            return resolve(token[1])
          handleGet = (data) ->
            requestKey = /input type="hidden" name="requestKey" value="([0-9a-f]+)"/.exec(data)
            signature = /input type="hidden" name="signature" value="([0-9a-f\/]+)"/.exec(data)
            if !requestKey || !signature
              return reject(t.NotHandled("Unable to get required parameters"))
            return $.post('/1/token/approve', { approve: 'Allow', requestKey: requestKey[1], signature: signature[1] }, handlePost)
            .fail (err) ->
              return reject(t.NotHandled((err && err.responseText) || "Failed to fetch token"))
          return $.get("/1/authorize?expiration=never&response_type=token&name=#{encodeURIComponent(name)}&scope=#{encodeURIComponent(scope)}&key=#{encodeURIComponent(key)}", handleGet)
          .fail (err) ->
            return reject(t.NotHandled((err && err.responseText) || "Unable to get required parameters"))
        )
      'track-event': (t, opts) ->
        { event } = getArgs(t, opts, {}, true)
        if !_.isObject(event) || _.isArray(event)
          throw t.NotHandled("Invalid event")
        defaultEventProps = {
          category: ''
          verb: ''
          dirObj: ''
          prepObj: ''
          indObj: ''
          method: ''
          context: ''
        }
        e = _.defaults(event, defaultEventProps)
        trackUe(e.category, e.verb, e.dirObj, e.prepObj, e.indObj, e.method, e.context)
        return

  mapHandlers(handlers)

iframeFromHost = (t) ->
  allIframes = document.querySelectorAll('iframe.plugin-iframe')
  _.find allIframes, (iframe) -> iframe.contentWindow == t.source

